import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-hrmasters',
  templateUrl: './hrmasters.component.html',
  styleUrls: ['./hrmasters.component.scss'],
  providers:[MasterService]
})
export class HrmastersComponent implements OnInit {

  

    // books: Book[];
     memberdetails:any[]=[];
     classdetails:any[]=[];
     closeResult: string;
     classes: any=[];
     section: any=[];
     student:boolean=true;
     staff:boolean=false;
     //objcls:any={};
     objclass:any={};
     objsec:any={};
     modalOptions:NgbModalOptions;
     private modalRef: NgbModalRef;
   
     constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }
   
     open(content) {
       this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
         this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
     }
   
     private getDismissReason(reason: any): string {
       if (reason === ModalDismissReasons.ESC) {
         return 'by pressing ESC';
       } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
         return 'by clicking on a backdrop';
       } else {
         return `with: ${reason}`;
       }
     }
   
     _keyPress(event: any) {
      if (event.charCode !== 0) {
        const pattern = /[0-9\+\-\ ]/;
        const inputChar = String.fromCharCode(event.charCode);
  
        if (!pattern.test(inputChar)) {
          // invalid character, prevent input
          event.preventDefault();
        }
      }
    }
   
     ngOnInit(): void {
       
       this.masclass();
       this.massection();
     }
   
   
     masclass() {
       this.mservice.get_hrmdept()
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.classes = resultArray;
              
           },
           error => console.log("Error :: " + error)
           )
     }
   
     openclass(content,objdata,cmd) {
       if(cmd=='insert')
       {
         this.objclass={};
        
         
         this.objclass.depid=0;
         this.objclass.sort='';
        // this.objclass.depid=0;
        // this.objclass.depid=0;
        
         this.objclass.oprtag='insert';
        
   
       }
   
       else if(cmd=='update')
       {
         this.objclass=objdata;
         this.objclass.oprtag='update';
       }
       
       this.modalOptions = {
         backdrop:'static',
         backdropClass:'customBackdrop',
         size:'sm'
        
        
       }
       this.modalRef=this.modalService.open(content,this.modalOptions);
       
       this.modalRef.result.then((result) => {
      
            
         }, (reason) => {
             
         });
     }
     
     opensec(content,objdata,cmd) {
       if(cmd=='insert')
       {
         this.objsec={};
        
         
         this.objsec.desid=0;
         this.objsec.sort='';
        
         this.objsec.oprtag='insert';
        
   
       }
   
       else if(cmd=='update')
       {
         this.objsec=objdata;
         this.objsec.oprtag='update';
       }
       
       this.modalOptions = {
         backdrop:'static',
         backdropClass:'customBackdrop',
         size:'sm'
        
        
       }
       this.modalRef=this.modalService.open(content,this.modalOptions);
       
       this.modalRef.result.then((result) => {
      
            
         }, (reason) => {
             
         });
     }
     saveclassdetails()
     {
   
   
       console.log('savedetails',this.objclass);
       this.mservice.Save_hrdept(this.objclass)
   .subscribe(result => {
      alert(result.message);
      
   if(result.status=='success')
   {
     let localmodref=this.modalRef;
   localmodref.close();
   //this.Refreshsummary();
   this.masclass();
   
   }
   
   
   else{
   
   
   }
      
   
     
       
   }, error => alert('error in connection')
   );
     }
   
     massection() {
       this.mservice.sel_sp_hrmdesig()
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.section = resultArray;
              
           },
           error => console.log("Error :: " + error)
           )
     }


     deldept(depid)
     {
   
      if(confirm('Are you sure you want to delete?'))
      {
      // console.log('savedetails',this.objsec);
       this.mservice.delhrmdept(depid)
   .subscribe(result => {
      alert(result.message);
      

   this.masclass();
     
       
   }, error => alert('error in connection')
   );
  }
     }
    
     deldesig(depid)
     {
   
   
      // console.log('savedetails',this.objsec);
      if(confirm('Are you sure you want to delete?'))
      {
       this.mservice.delhrmdesig(depid)
   .subscribe(result => {
      alert(result.message);
      

   this.massection();
     
       
   }, error => alert('error in connection')
   );
  }
     }
    
     
     savesection()
     {
   
   
       console.log('savedetails',this.objsec);
       this.mservice.Save_hrmdesig(this.objsec)
   .subscribe(result => {
      alert(result.message);
      
   if(result.status=='success')
   {
     let localmodref=this.modalRef;
   localmodref.close();
   //this.Refreshsummary();
   this.massection();
   
   }
   
   
   else{
   
   
   }
      
   
     
       
   }, error => alert('error in connection')
   );
     }
    
     // SaveclassDetails()
     // {
     //     debugger
     // //alert ('hi');
     // let clcd=localStorage.getItem('clcd');
     // let aycd=localStorage.getItem('aycd');
     // var clid = this.model.clid;
     // var clname = this.model.clname;
     // var clcode = this.model.clcode;
     // //var fyear = this.user.fyear;
     // var clsdata ={clid:clid, clname:clname,scode:clcode,fyear:clcode,clcd:clcd,aycd:aycd};
     
     // //console.log(f.value.clcode);
     // //this.closeModal();
     // this.model=f.value;
     
     // this.model.clcd=clcd;
     // this.model.aycd=aycd;
     // console.log('model',this.model);
     // this.SService.saveclassdtls(this.model)
     // .subscribe(result => {
     //     console.log('ret',JSON.stringify(result));
     //     alert (result.message);
     //     //this.alertmessage=result.message;
     
     // this.Getclasslist();
     // }, error => 
     // alert('error in connection')
     // //this.alertmessage='error in connection'
     // );
     
     // this.closeAddExpenseModal.nativeElement.click();
     
     // }
   
    
   }
